export default "__VITE_ASSET__2cac1685__"